import { Link } from 'react-router-dom';
import { Button } from '../ui/Button';
import { CONSULTATION_FEE_INR, CONSULTATION_DURATION_MINUTES } from '@bharat-consultancy/shared';

/**
 * "Talk to us before you pay" CTA — offered alongside every service so a
 * visitor who isn't ready to commit to a full service purchase can still
 * become a paying customer. Placed near the pricing table (the exact
 * moment a visitor is deciding whether to pay) rather than as a passive
 * mention, since that's where hesitation actually happens.
 */
export function ConsultCTA({ serviceId, serviceName }: { serviceId?: string; serviceName?: string }) {
  const params = new URLSearchParams();
  if (serviceId) params.set('serviceId', serviceId);
  if (serviceName) params.set('serviceName', serviceName);
  const query = params.toString();

  return (
    <div className="flex flex-col items-center gap-4 rounded-lg border-2 border-dashed border-marigold bg-marigold/10 p-6 text-center sm:flex-row sm:justify-between sm:text-left">
      <div>
        <p className="font-mono text-xs uppercase tracking-widest text-marigold-dark">Not sure yet?</p>
        <h3 className="mt-1 font-display text-lg font-semibold text-ink">
          Talk to a Consultant Before You Pay
        </h3>
        <p className="mt-1 text-sm text-ink/65">
          Book a {CONSULTATION_DURATION_MINUTES}-minute call for just ₹{CONSULTATION_FEE_INR} — we'll discuss your
          requirements and give you a clear quotation, no obligation to proceed.
        </p>
      </div>
      <Link to={`/consult${query ? `?${query}` : ''}`} className="shrink-0">
        <Button variant="accent" className="whitespace-nowrap">
          Book a {CONSULTATION_DURATION_MINUTES}-Min Call — ₹{CONSULTATION_FEE_INR}
        </Button>
      </Link>
    </div>
  );
}
